module.exports = __webpack_public_path__ + "static/img/no-content.b8de8e66.png";